import { Component, OnInit } from "@angular/core";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";

@Component({
  selector: "app-system-error",
  templateUrl: "./system-error.component.html",
  styleUrls: ["./system-error.component.css"],
  imports: SHARED_IMPORTS,
})
export class SystemErrorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
